import { DataLlave, EstadisticasLlave, EstadoLlaveAnual, ResumenByClienteProductoUsuario } from "../../bussines/entities/EstadisticasLlave.entity";
import { GetEstadoLlavesAnualParams } from "../../utils/params/EstadisticasDsKey.params";
import { FechaParams } from "../../utils/params/FechaParams.params";
import { EstadisticasDsKeyDtSource } from "../../bussines/dataSources/EstadisticasDsKeyDtSource";
import { transformacion } from 'lib.common';
import { format } from "date-fns";
import { appsUrlsApi } from "src/config/keys";
import { ErrExterno } from 'lib.common/dist/errorHandler';
import { Recurso } from "lib.common/dist/CleanArch";

export class EstadisticasDsKeyDtSourceImplRest implements EstadisticasDsKeyDtSource {
    async getEstadisticasLlaves(input: FechaParams): Promise<Recurso<EstadisticasLlave>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            let url = transformacion.appendUrl(appsUrlsApi.key, '/monitor/estadisticasLlaves');
            url.searchParams.append('fecha', fechaFormateada);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición estadisticas llaves del dsKey');
            }

            const data: EstadisticasLlave = await response.json();
            return Recurso.fromData<EstadisticasLlave>(data);
        } catch (error) {
            return Recurso.fromError<EstadisticasLlave>(new ErrExterno(error as Error));
        }
    }

    async getLlavesAnuladasMes(input: FechaParams): Promise<Recurso<DataLlave[]>> {
        try {
            const anio = input.fecha.getFullYear();
            const mes = input.fecha.getMonth();
            let url = transformacion.appendUrl(appsUrlsApi.key, '/monitor/llavesAnuladasMes');
            url.searchParams.append('anio', anio.toString());
            url.searchParams.append('mes', mes.toString());
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición llaves anuladas mes del dsKey.');
            }

            const data: DataLlave[] = await response.json();
            return Recurso.fromData<DataLlave[]>(data);
        } catch (error) {
            return Recurso.fromError<DataLlave[]>(new ErrExterno(error as Error));
        }
    }

    async getLlavesPorExpirar(): Promise<Recurso<DataLlave[]>> {
        try {
            let url = transformacion.appendUrl(appsUrlsApi.key, '/monitor/llavesPorExpirar');
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición llaves por expirar del dsKey');
            }

            const data: DataLlave[] = await response.json();
            return Recurso.fromData<DataLlave[]>(data);
        } catch (error) {
            return Recurso.fromError<DataLlave[]>(new ErrExterno(error as Error));
        }
    }

    async getEstadoLlavesAnual(input: GetEstadoLlavesAnualParams): Promise<Recurso<EstadoLlaveAnual[]>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            const codProducto = input.codProducto;
            let url = transformacion.appendUrl(appsUrlsApi.key, '/monitor/estadoLlavesAnual');
            url.searchParams.append('fecha', fechaFormateada);
            if (codProducto && codProducto.trim() != '') url.searchParams.append('codProducto', codProducto);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición estado llaves anual del dsKey');
            }

            const data: EstadoLlaveAnual[] = await response.json();
            return Recurso.fromData<EstadoLlaveAnual[]>(data);
        } catch (error) {
            return Recurso.fromError<EstadoLlaveAnual[]>(new ErrExterno(error as Error));
        }
    }

    async getResumenLlaves(input: FechaParams): Promise<Recurso<ResumenByClienteProductoUsuario[]>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            let url = transformacion.appendUrl(appsUrlsApi.key, '/monitor/resumenLlaves');
            url.searchParams.append('fecha', fechaFormateada);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición resumen llaves del dsKey');
            }

            const data: ResumenByClienteProductoUsuario[] = await response.json();
            return Recurso.fromData<ResumenByClienteProductoUsuario[]>(data);
        } catch (error) {
            return Recurso.fromError<ResumenByClienteProductoUsuario[]>(new ErrExterno(error as Error));
        }
    }
}